var React = require('react');

function RightArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#000","transform":"translate(1 1)"},[React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5","d":"M20 16.343L25.657 22 20 27.657","key":0}),React.createElement("circle",{"cx":"22","cy":"22","r":"22","key":1})]));
}

RightArrow.defaultProps = {"width":"46","height":"46","viewBox":"0 0 46 46"};

module.exports = RightArrow;

RightArrow.default = RightArrow;
